import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import '../../styles/home.css';
import banner from '../../img/banner.png';
import Cards from '../../components/Cards/Cards';
import crianca from '../../img/crianca2.png';
import Alinhamento from '../../components/Alinhamento/Alinhamento';
import Formulario from "../../components/Formulario/Formulario";
import Footer from "../../components/Footer/Footer";
import logoBranca from '../../img/logoBranca.png';
import { Link } from 'react-router-dom';

function Home() {

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const section = document.getElementById(hash.substring(1));
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <div>
      <Navbar expand="lg" className="bg-body-tertiary" id="navbar">
        <Container fluid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Navbar.Brand to="/" id="brand">
            <a href="/">
              <img src={logoBranca} style={{width:'auto', marginLeft:'15px'}} alt="logo"/>
            </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
              <Link to="/institucional" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Institucional</Link>
              <Link to="/" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}} onClick={() => scrollToSection('nascemosParaCuidar')}>Atuação</Link>
              <Link to="/blog" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Blog e notícias</Link> 
              <Link to="/formulario" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Incentivos fiscais</Link>
              <Link to="#contato" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}} onClick={() => scrollToSection('contato')}>Contato</Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="parteBaixo">
        <div className="banner">
          <img src={banner} id="imgBanner" alt="banner"/>
        </div>
        <p className="nasce" id="nascemosParaCuidar">Nascemos para cuidar</p>
        <p className="textFirst">Saúde, em seu sentido mais amplo, é o que norteia as iniciativas do Instituto Unimed Uberlândia. Uma <br /> associação sem fins lucrativos, que busca cuidar da comunidade de forma sustentável, oferecendo <br /> oportunidades de desenvolvimento humano. Por isso, os programas e projetos desenvolvidos ou apoiados <br /> pelo Instituto Unimed, dialogam com as seguintes frentes da atuação:</p>
        <Cards />
        <br /><br /><br />
      </div>
      <div className="parteBranca" style={{alignItems: 'center'}}>
        <div className="row m-auto" style={{marginTop:'5%'}}>
          <div className="col-12 col-md-6" id="criancaCol">
            <img src={crianca} id="crianca" className="img-fluid" alt="crianca"/>
          </div>
          <div className="col">
            <p className="programas">Programas que</p>
            <p className="transformam">Transformam Vidas</p>
            <br />
            <Alinhamento />
          </div>
        </div>
        <br /><br /><br id="contato"/>
        <Formulario />
      </div>
      <br /><br /><br /><br /><br />
      <Footer />
    </div>
  );
}

export default Home;
